export { PartnerAgreements as default } from "./partner-agreements";
